import { render, staticRenderFns } from "./staffRepairPage.vue?vue&type=template&id=0fa3c903&scoped=true"
import script from "./staffRepairPage.vue?vue&type=script&lang=js"
export * from "./staffRepairPage.vue?vue&type=script&lang=js"
import style0 from "./staffRepairPage.vue?vue&type=style&index=0&id=0fa3c903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa3c903",
  null
  
)

export default component.exports